module.exports = __webpack_public_path__ + "fonts/Roboto-Light.8be2d14.ttf";